<template>
  <div >
    <card>
      <!-- Card header -->
      <h3 slot="header" class="mb-0">
        <span class="text-muted"># {{orderindex}}.</span>
        {{title}}.{{tasktype ? " " + tasktype + ". " : "" }} {{level}}
      </h3>
      <!-- Card body -->
      <!-- Input groups with icon -->
      <div class="row">
        <div class="col-md-2">
          <b>Description</b>
        </div>
        <div class="col-md-10">
          <span v-html="htmldescription" />
        </div>
        <div class="col-md-2">
          <b>Files</b>
        </div>
        <div class="col-md-10">
          <div v-for="file in files" :key="file.name">
          
          <a target="blank" :href="fileurl + file.name">
            <i class="text-black ni file-text"></i>
            {{file.name.substring(
            file.name.indexOf("_") + 1
            )}}
          </a>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { ShowLink, HtmlNewLine, fileUrl } from "../../../services/helper";
export default {
  name: "task-item",
  props: {
    tasktype: String,
    title: String,
    description: String,
    level: String,
    orderindex: [String, Number],
    files: Array,
  },
  computed: {
    htmldescription() {
      return ShowLink(HtmlNewLine(this.description));
    },
    fileurl() {
      return fileUrl;
    },
  },
};
</script>